import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { CUIHeading } from 'connect-dot-com-ui-components/Components/CUIHeading/CUIHeading';
import HomepageMemberHighlightDesktopLayout from './HomepageMemberHighlightDesktopLayout';
import HomepageMemberHighlightMobileLayout from './HomepageMemberHighlightMobileLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Gradient({
  children
}) {
  return /*#__PURE__*/_jsx(CUIBox, {
    as: "span",
    display: "block",
    bgGradient: "linear(to-l, #CE4EAA, #F56271)",
    bgClip: "text",
    lineHeight: "52px",
    children: children
  });
}
export default function HomepageMemberHighlight() {
  return /*#__PURE__*/_jsxs(CUIBox, {
    mx: 6,
    my: 12,
    children: [/*#__PURE__*/_jsx(CUIHeading, {
      as: "h2",
      variant: "taglineTwo",
      textAlign: "center",
      mb: 8,
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.homepage.memberHighlight.heading_jsx",
        elements: {
          Gradient
        }
      })
    }), /*#__PURE__*/_jsx(HomepageMemberHighlightDesktopLayout, {
      display: {
        base: 'none',
        lg: 'flex'
      }
    }), /*#__PURE__*/_jsx(HomepageMemberHighlightMobileLayout, {
      display: {
        base: 'grid',
        lg: 'none'
      }
    })]
  });
}